// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__dSK-T","header":"MergedInvoice_header__3EVyS"};